module.exports = __webpack_public_path__ + "static/media/b0_p7_narration.268d8574.mp3";